import React from 'react'
import { Card, Grid, Text, NumberInput, TextInput, Select, Flex, Button } from '@mantine/core'

const GeneralConfiguration = ({
    officialVat,
    setOfficialVat,
    routes,
    setRoutes,
    defaultMethod,
    setDefaultMethod,
    sourceCountry,
    activeTabList,
    handleSave,
    loading
}) => {
    return (
        <Content>
            <Grid gutter="lg">
                <Grid.Col span={2}>
                    <Card withBorder p="xs" radius="sm" h="100%">
                        <Text size="xs" fw={600} mb={5}>Official VAT</Text>
                        <NumberInput
                            label="VAT Cost(%)"
                            placeholder="0"
                            value={officialVat}
                            onChange={(val) => setOfficialVat(val)}
                            min={0}
                            max={100}
                        />
                    </Card>
                </Grid.Col>

                <Grid.Col span={5}>
                    <Card withBorder p="xs" radius="sm" h="100%">
                        <Text size="xs" fw={600} mb={5}>Routes</Text>
                        <Grid gutter="xs">
                            <Grid.Col span={6}>
                                <TextInput
                                    label="Country From"
                                    value={sourceCountry?.attributes?.name || ''}
                                    disabled
                                    bg="gray.1"
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <TextInput
                                    label="Rute"
                                    placeholder=""
                                    value={routes}
                                    onChange={(e) => setRoutes(e.target.value)}
                                />
                            </Grid.Col>
                        </Grid>
                    </Card>
                </Grid.Col>

                <Grid.Col span={5}>
                    <Card withBorder p="xs" radius="sm" h="100%">
                        <Text size="xs" fw={600} mb={5}>Default Shipment Method</Text>
                        <Grid gutter="xs">
                            <Grid.Col span={6}>
                                <TextInput
                                    label="Country From"
                                    value={sourceCountry?.attributes?.name || ''}
                                    disabled
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Select
                                    label="Shipment Method"
                                    data={activeTabList.map(m => ({ value: m.value, label: m.label }))}
                                    value={defaultMethod}
                                    onChange={setDefaultMethod}
                                    placeholder="Select"
                                    clearable
                                />
                            </Grid.Col>
                        </Grid>
                    </Card>
                </Grid.Col>
            </Grid>

            <Flex justify="flex-end" mt="lg">
                <Button color="red" onClick={handleSave} loading={loading}>Save</Button>
            </Flex>
        </Content>
    )
}

// Wrapper to avoid semantic issues or just use Fragment
const Content = ({ children }) => <>{children}</>

export default GeneralConfiguration
